import { RoleResource, roleResource } from '@witkac/kartamiejska-resources';
import { RoleObjectType } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';
import rolePermission from './role/rolePermissions.module';

export class RolesModule extends EntityModule<RoleObjectType, RoleResource> {
  public modules = { rolePermission };

  constructor() {
    super(roleResource);

    this.actions = {
      ...this.actions,
      /**
       * Dodaje rolę
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      add: async (context: any, data: any): Promise<void> => {
        const args = { name: data.name, parentId: data.parent.id };
        data.id = await this.resource.add(args);
        context.commit('add', data);
        context.commit('incrementCount');
      },
      /**
       * Aktualizuje rolę
       *
       * @param context context
       * @param data dane encji
       */
      update: async (context: any, data: any): Promise<void> => {
        const args = { id: data.id, name: data.name };
        await this.resource.update(args.id as number, data);
        context.commit('update', data);
        context.commit('setEntity', data);
      }
    };
  }
}

export default new RolesModule();
